import { Stack } from "@mui/material";
import Chip from "components/Chip";
import { CustomModal } from "components/CustomModal";
import { CrremSubsetInput } from "features/crrem-pathway-chart/components/CrremSubsetInput";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { downloadCrremEnergyInputTemplate } from "../api/callers";
import { EnergyAnalysisEnergyInput } from "./EnergyAnalysisEnergyInput";

const UPLOAD_TABS = {
  energy: "energy",
  subset: "subset",
} as const;

type EnergyAnalysisEnergyInputModalProps = {
  disabled?: boolean;
  modalOpen: boolean;
  onUpload: (file: File) => void;
  projectId: string;
  setModalOpen: (open: boolean) => void;
};

type UploadTab = (typeof UPLOAD_TABS)[keyof typeof UPLOAD_TABS];

export const EnergyAnalysisEnergyInputModal = ({
  disabled,
  modalOpen,
  onUpload,
  projectId,
  setModalOpen,
}: EnergyAnalysisEnergyInputModalProps) => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<UploadTab>(UPLOAD_TABS.energy);
  useEffect(() => {
    if (modalOpen) setTab(UPLOAD_TABS.energy);
  }, [modalOpen]);
  return (
    <CustomModal
      height="auto"
      modalOpen={modalOpen}
      padding="0.5rem 2.4rem 2.4rem 2.4rem"
      setModalOpen={setModalOpen}
      width="36rem"
    >
      <Stack className="w-full min-w-0 flex-col items-stretch gap-4">
        <Stack className="min-h-[3.2rem] items-center gap-2 pr-10">
          <Chip isOn={tab === UPLOAD_TABS.energy} onClick={() => setTab(UPLOAD_TABS.energy)}>
            {t("BuildingProfile.energyAnalysis.energyInput")}
          </Chip>
          <Chip isOn={tab === UPLOAD_TABS.subset} onClick={() => setTab(UPLOAD_TABS.subset)}>
            {t("BuildingProfile.crremPathway.subset.tab")}
          </Chip>
        </Stack>
        {tab === UPLOAD_TABS.subset ? (
          <CrremSubsetInput disabled={disabled} hideTitle projectId={projectId} />
        ) : (
          <EnergyAnalysisEnergyInput
            disabled={disabled}
            hideTitle
            isUploading={disabled}
            onDownload={() => downloadCrremEnergyInputTemplate(String(t("general.downloadFileProblem")))}
            onUpload={onUpload}
          />
        )}
      </Stack>
    </CustomModal>
  );
};
